'use strict';

var React = require('react');

var SvgVariantIcon = function SvgVariantIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.01 13.99c.122 1.406 1.302 2.51 2.74 2.51h5c1.519 0 2.75-1.231 2.75-2.75v-5c0-1.438-1.104-2.618-2.51-2.74-.122-1.406-1.302-2.51-2.74-2.51h-5c-1.519 0-2.75 1.231-2.75 2.75v5c0 1.438 1.104 2.618 2.51 2.74Zm-.01-5.24c0-1.519 1.231-2.75 2.75-2.75h3.725c-.116-.57-.62-1-1.225-1h-5c-.69 0-1.25.56-1.25 1.25v5c0 .605.43 1.11 1 1.225v-3.725Zm1.5 4.836v-4.836c0-.69.56-1.25 1.25-1.25h4.836l-6.086 6.086Zm7.5.164v-4.836l-6.086 6.086h4.836c.69 0 1.25-.56 1.25-1.25Z"
  }));
};
SvgVariantIcon.displayName = "VariantIcon";

exports.SvgVariantIcon = SvgVariantIcon;
